import {Component, Input} from '@angular/core';
import {EstadoOnboardingPainel, PASSOS_ONBOARDING} from '../onboarding-painel.service';

const VISUAL: Record<string, {icone: string; titulo: string}> = {
  cardapio: {icone: 'fas fa-book-open', titulo: 'Cardápio'},
  loja: {icone: 'fas fa-store', titulo: 'Como sua loja funciona'},
  horarios: {icone: 'far fa-clock', titulo: 'Horários'},
  pagamento: {icone: 'far fa-credit-card', titulo: 'Pagamento'},
  receber: {icone: 'fas fa-bell', titulo: 'Onde você recebe os pedidos'},
  teste: {icone: 'fas fa-shopping-bag', titulo: 'Seu primeiro pedido'}
};

/** Cabeçalho comum dos passos: voltar, "Passo N de 6", ícone colorido, título e o vídeo curto. */
@Component({
  selector: 'app-onb-moldura',
  template: `
    <a class="onb-voltar" routerLink="/admin/comecar"><i class="fas fa-chevron-left"></i> Primeiros passos</a>
    <div class="onb-eyebrow">Passo {{ numero }} de {{ total }}</div>
    <div class="onb-titulo">
      <span class="onb-ic onb-ic--{{ passo }}"><i [class]="visual.icone"></i></span>
      <h1>{{ visual.titulo }}</h1>
    </div>
    <p class="onb-sub" *ngIf="subtitulo">{{ subtitulo }}</p>
    <app-onb-video [passo]="passo"></app-onb-video>
    <app-onb-bonus class="onb-moldura-bonus" *ngIf="estado" [estado]="estado" formato="faixa"></app-onb-bonus>
    <ng-content></ng-content>
  `,
  styleUrls: ['./onb-moldura.component.scss']
})
export class OnbMolduraComponent {
  @Input() passo = 'cardapio';
  @Input() subtitulo = '';
  /** com o estado, o prêmio aparece como faixa logo abaixo do título */
  @Input() estado: EstadoOnboardingPainel | null = null;
  readonly total = PASSOS_ONBOARDING.length;

  get numero(): number { return PASSOS_ONBOARDING.indexOf(this.passo as any) + 1; }
  get visual(): {icone: string; titulo: string} { return VISUAL[this.passo] || VISUAL.cardapio; }
}
